module.exports = __webpack_public_path__ + "media/images/home/main/viesi-2abad00789a52f65e06b9c576ce3f296.png";